export const getSatser = async (): Promise<Satser> => {
    const response = await fetch('/api/mt1535/satser/hoyskoleoguniversitet');

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};

export interface Satser {
    ST01_MaksBasisstotteperManed: number;
    ST01_MaksSkolepengestottePerAr: number;
}
